import { Tooltip } from '@mui/material';
import * as Styled from './TooltipButton.styles';
import { ITooltipButton } from './TooltipButton.types';

const TooltipButton = ({ description, placement, disable, icon, onClick, label, ...otherProps }: ITooltipButton) => {
  return (
    <Tooltip title={description} placement={placement}>
      <Styled.TogglePreviousButton startIcon={icon} onClick={!disable ? onClick : undefined} {...otherProps}>
        {label}
      </Styled.TogglePreviousButton>
    </Tooltip>
  );
};
export default TooltipButton;
